import { useGetHomeDataQuery } from "../../store/api/homeApi";
import { useGetLifetimeEarningsQuery } from "../../store/api/walletApi";

export const SidePanel = () => {
  const { data } = useGetLifetimeEarningsQuery("");
  const { data: homeData } = useGetHomeDataQuery();
  console.log(homeData);
  return (
    <div className="flex flex-col">
      <div className="text-primary-900 text-4xl font-bold leading-10 tracking-wide mb-8 md:hidden px-3">
        My Wallet
      </div>
      <div className="flex flex-col gap-4 w-full md:w-min">
        <div className="p-4 w-full md:w-96 bg-white rounded-xl md:border md:border-[#ebebeb] flex-col justify-center items-center gap-5 inline-flex">
          <div className="px-1 w-full py-4 bg-neutral-100 rounded-lg border border-[#ecd996] flex-col justify-center items-center gap-4 inline-flex">
            <div className="flex items-center justify-between w-full gap-2 pb-4 border-b border-b-primary-400 px-3">
              <img
                alt=""
                src="/assets/logo/OneGoldCoin.png"
                className="w-6 h-6"
              />
              <p className="flex-grow text-primary-900 text-base font-bold leading-normal ">
                Coins
              </p>
              <p className="text-xl font-bold">
                {homeData?.data?.account_balances?.coins}
              </p>
            </div>
            <div className="flex items-center justify-between w-full gap-2 px-3">
              <img
                alt=""
                src="/assets/icons/star-red.png"
                className="w-6 h-6"
              />
              <p className="flex-grow text-primary-900 text-base font-bold leading-normal">
                XP
              </p>
              <p className="text-xl font-bold">
                {homeData?.data?.account_balances?.xp}
              </p>
            </div>
          </div>
          <div className="flex justify-around items-center gap-0.5">
            <p className="text-base text-primary-900 leading-snug">
              Lifetime Earnings{" "}
              <span className="font-semibold">{data?.sum}</span>
            </p>
            <img src="/assets/logo/OneGoldCoin.png" className="w-3 h-3" />
          </div>
        </div>
        {/* <div className="bg-[#EBEBEB] pt-5 rounded-t-2xl px-4 md:bg-white md:p-0 md:rounded-none">
          <div className="px-4 py-2 md:p-4 md:w-full md:mx-0 bg-[#faf5e5] rounded-xl border border-[#ebebeb] md:flex-col justify-between md:justify-start items-center gap-4 flex">
            <div className="flex items-start md:items-center gap-2">
              <ShoppingBag size={"32"} />
              <p className="font-normal text-neutral-700 text-md text-wrap w-fit md:text-xl md:ml-3">
                Check out our merchandise in our store!
              </p>
            </div>
            <button
              type="button"
              className="text-white bg-[#007aff] rounded-3xl md:rounded-xl text-xs md:text-base font-bold py-2 md:py-3.5 px-3 md:px-20"
            >
              Explore
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};
